/* sg-search-page: filtros sin recargar, orden, vista, cajón móvil y «También buscan». Sin textos propios. */
if (!customElements.get('sg-search-page')) {
  class SgSearchPage extends HTMLElement {
    connectedCallback() {
      this.live = this.querySelector('[data-sg-sr-live]');
      this.timer = null;
      this.abort = null;
      this.sectionId = this.dataset.sectionId;

      this.addEventListener('change', (e) => this.onChange(e));
      this.addEventListener('input', (e) => {
        if (e.target.matches('[data-sg-sr-price]')) this.debounce();
        if (e.target.matches('[data-sg-sr-lo], [data-sg-sr-hi]')) this.slide(e.target);
        if (e.target.matches('[data-sg-sr-find]')) this.find(e.target);
      });
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('submit', (e) => {
        if (e.target.matches('[data-sg-sr-form]')) {
          e.preventDefault();
          this.apply();
        }
      });
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.setDrawer(false));
      window.addEventListener('popstate', () => this.load(window.location.href, false));

      this.restoreView();
      this.initRanges();
      this.syncCounts();
      this.loadAlso();
    }

    /* Los números de los filtros cuentan opciones elegidas (una familia de color = 1). */
    syncCounts() {
      this.querySelectorAll('.sg-sr__group').forEach((group) => {
        const summary = group.querySelector('summary');
        let badge = summary.querySelector('i');
        const n = group.querySelectorAll('input[type="checkbox"]:checked').length
          + (group.querySelector('[data-sg-sr-range]') && (group.querySelector('[data-sg-sr-min]').value || group.querySelector('[data-sg-sr-max]').value) ? 1 : 0);
        if (n > 0) {
          if (!badge) {
            badge = document.createElement('i');
            summary.insertBefore(badge, summary.querySelector('svg'));
          }
          badge.textContent = String(n);
        } else if (badge) {
          badge.remove();
        }
      });
      const total = this.querySelectorAll('.sg-sr__active .sg-sr__tag').length;
      const btn = this.querySelector('.sg-sr__filter-btn');
      if (btn) {
        let badge = btn.querySelector('i');
        if (total > 0) {
          if (!badge) {
            badge = document.createElement('i');
            btn.append(badge);
          }
          badge.textContent = String(total);
        } else if (badge) {
          badge.remove();
        }
      }
    }

    money(value) {
      return new Intl.NumberFormat(this.dataset.locale || undefined, {
        style: 'currency',
        currency: this.dataset.currency || 'MXN',
        maximumFractionDigits: 0,
      }).format(value);
    }

    /* Deslizador doble de precio: relleno, etiquetas y valores enviados. */
    initRanges() {
      this.querySelectorAll('[data-sg-sr-range]').forEach((box) => this.paintRange(box));
    }

    paintRange(box) {
      const lo = box.querySelector('[data-sg-sr-lo]');
      const hi = box.querySelector('[data-sg-sr-hi]');
      const top = Number(box.dataset.top) || 1;
      const a = Number(lo.value);
      const b = Number(hi.value);
      box.querySelector('[data-sg-sr-fill]').style.cssText = `left:${(a / top) * 100}%;right:${100 - (b / top) * 100}%`;
      box.querySelector('[data-sg-sr-lo-label]').textContent = this.money(a);
      box.querySelector('[data-sg-sr-hi-label]').textContent = this.money(b);
      box.querySelector('[data-sg-sr-min]').value = a > 0 ? String(a) : '';
      box.querySelector('[data-sg-sr-max]').value = b < top ? String(b) : '';
      lo.style.zIndex = a >= top - 100 ? '3' : '2';
    }

    slide(input) {
      const box = input.closest('[data-sg-sr-range]');
      const lo = box.querySelector('[data-sg-sr-lo]');
      const hi = box.querySelector('[data-sg-sr-hi]');
      if (Number(lo.value) > Number(hi.value)) {
        if (input === lo) lo.value = hi.value;
        else hi.value = lo.value;
      }
      this.paintRange(box);
    }

    /* Buscador dentro de la lista de modelos. */
    find(input) {
      const q = input.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const body = input.closest('.sg-sr__group-body');
      let shown = 0;
      body.querySelectorAll('[data-sg-sr-find-list] li').forEach((li) => {
        const name = (li.dataset.name || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const hit = !q || name.includes(q);
        li.hidden = !hit;
        if (hit) shown += 1;
      });
      const none = body.querySelector('[data-sg-sr-find-none]');
      if (none) none.hidden = shown > 0;
    }

    form() {
      return this.querySelector('[data-sg-sr-form]');
    }

    onChange(e) {
      const t = e.target;
      if (t.matches('input[data-group="model"]') && t.checked) {
        this.querySelectorAll('input[data-group="model"]').forEach((o) => { if (o !== t) o.checked = false; });
      }
      if (t.closest('[data-sg-sr-form]') || t.matches('[data-sg-sr-sort]')) this.apply();
    }

    onClick(e) {
      const view = e.target.closest('[data-sg-sr-view]');
      if (view) return this.setView(view.dataset.sgSrView);
      if (e.target.closest('[data-sg-sr-open]')) return this.setDrawer(true);
      if (e.target.closest('[data-sg-sr-close]')) return this.setDrawer(false);
      const untagFamily = e.target.closest('[data-sg-sr-untag-family]');
      if (untagFamily) {
        const fam = untagFamily.dataset.sgSrUntagFamily;
        this.querySelectorAll('input[data-family]').forEach((o) => { if (o.dataset.family === fam) o.checked = false; });
        this.apply();
        return undefined;
      }
      const untag = e.target.closest('[data-sg-sr-untag]');
      if (untag) {
        const value = untag.dataset.sgSrUntag;
        this.querySelectorAll('input[name="sg_tag"]').forEach((o) => { if (o.value === value) o.checked = false; });
        this.apply();
        return undefined;
      }
      const link = e.target.closest('[data-sg-sr-link]');
      if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        this.load(link.href, true);
      }
      return undefined;
    }

    debounce() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.apply(), 650);
    }

    /* Convierte el formulario (y el orden) en la URL de la búsqueda. */
    apply() {
      const form = this.form();
      if (!form) return;
      clearTimeout(this.timer);
      const data = new FormData(form);
      const params = new URLSearchParams();
      data.forEach((value, key) => {
        const v = String(value).trim();
        if (v !== '') params.append(key, v);
      });
      /* Modelo y promoción viajan dentro de la búsqueda como etiquetas. */
      const tags = params.getAll('sg_tag');
      params.delete('sg_tag');
      if (tags.length) {
        const base = (params.get('q') || '').trim();
        params.set('q', [base, ...tags.map((t) => `tag:"${t}"`)].join(' ').trim());
      }
      /* Opciones repetidas que se muestran como una sola: se envían todas juntas. */
      form.querySelectorAll('input[data-extra]:checked').forEach((input) => {
        new URLSearchParams(input.dataset.extra).forEach((value, key) => {
          if (!params.getAll(key).includes(value)) params.append(key, value);
        });
      });
      this.load(`${form.action}?${params.toString()}`, true);
    }

    async load(url, push) {
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      const open = [...this.querySelectorAll('.sg-sr__group[open]')].map((d) => d.dataset.group);
      const closed = [...this.querySelectorAll('.sg-sr__group:not([open])')].map((d) => d.dataset.group);
      this.live.classList.add('is-loading');
      try {
        const target = new URL(url, window.location.origin);
        target.searchParams.delete('sections');
        target.searchParams.delete('section_id');
        const res = await fetch(target.toString(), { signal: this.abort.signal, headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-sg-sr-live]');
        if (!next) throw new Error('sin contenido');
        this.live.innerHTML = next.innerHTML;
        this.querySelectorAll('.sg-sr__group').forEach((d) => {
          if (open.includes(d.dataset.group)) d.open = true;
          if (closed.includes(d.dataset.group)) d.open = false;
        });
        this.restoreView();
        this.initRanges();
        this.syncCounts();
        if (push) {
          const clean = new URL(url, window.location.origin);
          clean.searchParams.delete('sections');
          window.history.pushState({}, '', clean.pathname + clean.search);
          if (!this.classList.contains('is-filters-open')) {
            const top = this.getBoundingClientRect().top + window.scrollY - 140;
            if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
          }
        }
      } catch (err) {
        if (err.name !== 'AbortError') window.location.href = url;
      } finally {
        this.live.classList.remove('is-loading');
      }
    }

    setDrawer(open) {
      this.classList.toggle('is-filters-open', open);
      document.documentElement.classList.toggle('sg-sr-lock', open);
    }

    setView(mode) {
      try { localStorage.setItem('sg-sr-view', mode); } catch (e) { /* sin almacenamiento */ }
      this.dataset.view = mode;
      this.querySelectorAll('[data-sg-sr-view]').forEach((b) => {
        const on = b.dataset.sgSrView === mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
    }

    restoreView() {
      let mode = 'grid';
      try { mode = localStorage.getItem('sg-sr-view') || 'grid'; } catch (e) { /* sin almacenamiento */ }
      this.setView(mode === 'list' ? 'list' : 'grid');
    }

    async loadAlso() {
      const box = this.querySelector('[data-sg-sr-also]');
      const list = this.querySelector('[data-sg-sr-also-list]');
      const q = (this.dataset.terms || '').trim();
      if (!box || !list || !q) return;
      try {
        const params = new URLSearchParams({ q, 'resources[type]': 'query', 'resources[limit]': '8' });
        const res = await fetch(`${this.dataset.suggestUrl}.json?${params}`);
        if (!res.ok) return;
        const queries = (await res.json()).resources.results.queries || [];
        const seen = new Set([q.toLowerCase()]);
        queries.forEach((item) => {
          const text = String(item.text || '').trim();
          if (!text || seen.has(text.toLowerCase()) || seen.size > 6) return;
          seen.add(text.toLowerCase());
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = item.url;
          a.textContent = text;
          li.append(a);
          list.append(li);
        });
        box.hidden = list.children.length === 0;
      } catch (err) { /* sin sugerencias */ }
    }
  }

  customElements.define('sg-search-page', SgSearchPage);
}
